module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'mbx-info\'>\n    Are you sure you want to disable this integration?\n</div>\n';

}
return __p
}